import { ReactNode } from 'react'
import { Link } from 'react-router-dom'

/**
 * Container for form actions (buttons, links) with consistent spacing
 */
interface AuthFormActionsProps {
  children: ReactNode
  gap?: 2 | 3
}

export function AuthFormActions({ children, gap = 2 }: AuthFormActionsProps) {
  return <div className={`flex flex-col gap-${gap}`}>{children}</div>
}

/**
 * Footer links for auth pages with consistent styling
 */
interface AuthFooterLinksProps {
  links: Array<{
    to: string
    label: string
  }>
  prefix?: string
}

export function AuthFooterLinks({ links, prefix }: AuthFooterLinksProps) {
  return (
    <div className="text-sm text-center text-muted-foreground mt-3">
      {prefix && <span>{prefix} </span>}
      {links.map((link, index) => (
        <span key={link.to}>
          {index > 0 && <span className="mx-2">&middot;</span>}
          <Link to={link.to} className="hover:text-foreground">
            {link.label}
          </Link>
        </span>
      ))}
    </div>
  )
}
